import React from 'react';
import { IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import styles from './growthCurve.module.css';
import CalendarConfig from '../../../../consts/CalendarConfig';
import { GROWTH_INDICATORS, formatNumber, formatPercentile, formatZ } from '../../modules/growth/growthIndicators';

/**
 * Histórico das medições, da mais recente para a mais antiga: data, idade e,
 * por indicador, o valor com percentil e escore-z. Medida ausente é "—".
 *
 * `statsList`: saída de growthStatsList; `enabled`: mostra editar/excluir.
 * `classes`: troca as classes da tabela (o PDF usa as do papel).
 */
const GrowthHistoryTable = ({ statsList, enabled = false, onEdit, onDelete, classes }) => {
    const css = classes || styles;
    const rows = [...statsList].reverse();

    const cell = (stats, indicator) => {
        const item = stats.indicators[indicator.key];
        if (!item) return <span className={styles.missing}>—</span>;
        return (
            <div className={styles.cellValue}>
                <span>{formatNumber(item.value, indicator.digits)}</span>
                {item.status === 'ok' && (
                    <span className={`${styles.cellStats} ${item.implausible ? styles.cellAlert : ''}`}>
                        P {formatPercentile(item.percentile)} · z {formatZ(item.z)}
                    </span>
                )}
            </div>
        );
    };

    return (
        <div className={classes ? undefined : styles.tableScroll}>
            <table className={css.table}>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Idade</th>
                        {GROWTH_INDICATORS.map((indicator) => (
                            <th key={indicator.key} className={css.num}>{indicator.short} ({indicator.unit})</th>
                        ))}
                        {enabled && <th aria-label="Ações" />}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((stats) => (
                        <tr key={stats.measurement.id}>
                            <td>{CalendarConfig.GetDDMMAAAA(stats.measurement.measuredAt)}</td>
                            <td>{stats.ageLabel}</td>
                            {GROWTH_INDICATORS.map((indicator) => (
                                <td key={indicator.key} className={css.num}>{cell(stats, indicator)}</td>
                            ))}
                            {enabled && (
                                <td className={styles.actionsCell}>
                                    <IconButton size="small" aria-label="Editar medição" onClick={() => onEdit(stats.measurement)}>
                                        <EditOutlinedIcon fontSize="inherit" />
                                    </IconButton>
                                    <IconButton size="small" aria-label="Excluir medição" onClick={() => onDelete(stats.measurement)}>
                                        <DeleteOutlineIcon fontSize="inherit" />
                                    </IconButton>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default GrowthHistoryTable;
